import Alpine from 'alpinejs'

window.Alpine = Alpine;
window.Alpine.start();
